export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-align-center-7cc0e07a47c398b4844f00f34a1f624e.svg";